var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDesign
    ? _c("div", { staticClass: "ds-platform-card-item-by-teacherlist" }, [
        _c(
          "div",
          { staticClass: "avatar-wrap" },
          [_c("dsf-image", { staticClass: "avatar" })],
          1
        ),
        _vm._m(0),
      ])
    : _c(
        "div",
        {
          staticClass: "ds-platform-card-item-by-teacherlist",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm._clickBefore(_vm.courseClick)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "avatar-wrap" },
            [
              _c("dsf-image", {
                staticClass: "avatar",
                attrs: {
                  src: _vm._f("imgFormat")(_vm.data["avatar"]),
                  "error-src": _vm.errorSrc,
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "info" }, [
            _c(
              "p",
              { staticClass: "name", attrs: { title: _vm.data["name"] } },
              [_vm._v(_vm._s(_vm.data["name"]))]
            ),
            _c(
              "p",
              { staticClass: "line-1", attrs: { title: _vm.data["unit"] } },
              [_vm._v(_vm._s(_vm.data["unit"]))]
            ),
            _c(
              "p",
              { staticClass: "line-1", attrs: { title: _vm.data["position"] } },
              [_vm._v(_vm._s(_vm.data["position"]))]
            ),
            _c("p", { staticClass: "course" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.data["courseNum"]) +
                  _vm._s(_vm.getSuffix("courseNum")) +
                  " > "
              ),
            ]),
          ]),
        ]
      )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info" }, [
      _c("p", { staticClass: "name" }, [_vm._v("张三")]),
      _c("p", { staticClass: "line-2" }, [
        _vm._v("中央党校（国家行政学院）副校长"),
      ]),
      _c("p", { staticClass: "course" }, [_vm._v("15门精品课程 >")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }